import './burgermenu.css';
// eslint-disable-next-line import/named
import { CustomUserClaim } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { config } from "../../utils/config/config";
import { Article } from '../../services/coworkerApiCalls/Article/ArticlesTypes';
import { useDataApiArticleByCategoryBySpace } from '../../Hooks/useDataArticlesApi';
import { useDataApiServices, useDataApiSpacesByServiceId } from '../../Hooks/useDataServicesApi';
import { useDataApi as useDataUsersApi } from '../../Hooks/useDataUsersApi';
import { useEffect, useState } from 'react';
import { ServiceUser } from '../../services/coworkerApiCalls/User/User';
import React from 'react';
import Modal from 'react-modal';

function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
    // Vérifie si 'customClaim' est déjà un tableau
    // eslint-disable-next-line unicorn/prefer-ternary
    if (Array.isArray(customClaim)) {
        return customClaim;
    } else {
        // Si ce n'est pas un tableau, on l'encapsule dans un tableau
        return [customClaim];
    }
}
/**
 * @function BurgerMenu displays the mobile version of the navigation menu
 * @returns {JSX.Element} HTML content
 */
function BurgerMenu() {
    const { authState } = useOktaAuth();
    const groups = authState!.idToken!.claims.groups;
    const token = authState!.idToken!.idToken;

    // eslint-disable-next-line unicorn/consistent-function-scoping
    const handleNavigation = (path: string) => {
        window.location.href = path; // Change l'URL et recharge la page
    };
    const delayNavigation = (path: string, delay: number) => {
      setTimeout(() => {
        handleNavigation(path);
      }, delay);
    };

    const { oktaAuth } = useOktaAuth();
    const handleLogout = async () => {
      try {
        const redirectUri = window.location.origin;
        await oktaAuth.signOut({
          postLogoutRedirectUri: redirectUri + '/Account/PostLogout'
        });
      } catch (error) {
        console.error('Erreur lors de la tentative de connexion:', error);
      }
  
    };

     // To have the last space choosed by the user 
     const initialLocalStorageSpaceId = localStorage.getItem("ID_SPACE");
     const connectedUser = useDataUsersApi();
     const [spaceByServiceIdEdit, setSpacesByServiceIdEdit] = useState(
        initialLocalStorageSpaceId ? Number.parseInt(initialLocalStorageSpaceId, 10) : 76
     );

    // A REVOIR POUR LE COWORKING DE BASE OU LE COMPORTEMENT AVEC IDDEPARTMENT = 1  QUAND connectedUser?.idDepartment = undefined
    const allSpacesByServiceId = useDataApiSpacesByServiceId(connectedUser?.idDepartment || 1);

    // if space id change due to a new choice of the user in select menu, the value in local storage will also change
    useEffect(() => {
        localStorage.setItem("ID_SPACE", JSON.stringify(spaceByServiceIdEdit));
    }, [spaceByServiceIdEdit]);

    // if we don't have a charter or informations section, no links in navbar.
    const charter: Article | undefined = useDataApiArticleByCategoryBySpace(5);
    const informations : Article | undefined = useDataApiArticleByCategoryBySpace(3);
    const restaurants : Article | undefined = useDataApiArticleByCategoryBySpace(4);

    const handleSpaceByServiceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = Number.parseInt(event.target.value);
        if (selectedValue !== 0) { // Vérifie si la valeur sélectionnée n'est pas 0
            setSpacesByServiceIdEdit(selectedValue);
            // To refresh the website with the previous selected space.
            delayNavigation("/", 0);
        }
    };

    
    // Modal 

    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [serviceIdEdit, setServiceIdEdit] = useState(1);
    const [spaceIdEdit, setSpaceIdEdit] = useState(0);
    const allSpaces = useDataApiSpacesByServiceId(serviceIdEdit);
    const allServices = useDataApiServices();

    const handleServiceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = Number.parseInt(event.target.value);
        if (selectedValue !== 0) { // Vérifie si la valeur sélectionnée n'est pas 0
            setServiceIdEdit(selectedValue);
        }
    };

    const handleSpaceIdChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSpaceIdEdit(Number.parseInt(event.target.value));
    };
    
    function closeModal() {
        setModalIsOpen(false);
    }

    // To display the modal when the site doesn't have an ID_SPACE in local storage
    useEffect(() => {
        const storedValue = localStorage.getItem("ID_SPACE");
        if(storedValue){
            const parseValue  = Number.parseInt(storedValue, 10);
            if (parseValue == undefined || parseValue == 76) { 
                setModalIsOpen(true);
            }
        }
       
    }, []); 
    
    const modalStyles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white', // Fond blanc comme vos cartes
        padding: '2rem', // Ajouter un peu d'espace intérieur
        borderRadius: '0.5rem', // Arrondir les coins
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)', // Ombre pour la profondeur
        width: '80%', // Ajustez la largeur selon vos besoins
        maxWidth: '800px', // Largeur maximale pour les grands écrans
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Fond semi-transparent pour l'overlay
      },
    };

    const handleSubmit = (event: React.FormEvent) => {
      event.preventDefault();
      void ServiceUser(token, serviceIdEdit)
      localStorage.setItem("ID_SPACE", JSON.stringify(spaceIdEdit));
      delayNavigation("/", 2000);
      closeModal();
    }


      
    return (
        <ul className="navigationBar sm:hidden z-50 items-center">
            <li className="navigationElement" onClick={() => handleNavigation('/')}>Réservation</li>
                {informations?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/informations')}>Informations</li>
                }
                {charter?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/charte')}>Charte Coworking</li>
                }
                {restaurants?.id != 0 &&
                    <li className="navigationElement" onClick={() => handleNavigation('/restaurants')}>Restaurants</li>

                }
                {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
                <>
                    <li className="navigationElement" onClick={() => handleNavigation('/articles')}>Articles</li>
                    <li className="navigationElement" onClick={() => handleNavigation('/spaces')}>Espaces</li>
                    <li className="navigationElement" onClick={() => handleNavigation('/departments')}>Services</li>
                </>
                : <>
                </>}
                
                {allSpacesByServiceId && (
                    <select
                        name="spacesByServiceId"
                        value={spaceByServiceIdEdit || ''}
                        onChange ={handleSpaceByServiceIdChange}
                        className="mt-1 block text-black w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                    >
                        <option value={0}>Choisir l'espace</option>
                        {allSpacesByServiceId.map((space) => (
                            <option key={space.id} value={space.id}>
                                {space.name}
                            </option>
                        ))}
                        {allSpacesByServiceId.length === 0 && (
                            <option value="" disabled>
                                Aucune espace n'est disponible.
                            </option>
                        )}
                    </select>
                )}
                {modalIsOpen && 
                    <div>
                        <Modal
                            isOpen={modalIsOpen}
                            contentLabel="Bienvenue et choix du service"
                            style={modalStyles}
                        >
                            <form onSubmit={handleSubmit} action="/articles" method="post" className="flex flex-col gap-6 rounded-lg p-8">
                            <h2 className="text-2xl font-semibold">Bienvenue sur votre espace CoWorking !</h2>
                            <p className="mb-2">Veuillez configurer votre espace :</p>
                            {allServices && (
                                <div className="form-group w-full md:w-1/2">
                                <label htmlFor="categoryId" className="text-lg font-semibold mb-2">Liste des services</label>
                                <select
                                    name="categoryId"
                                    value={serviceIdEdit || ''}
                                    onChange={handleServiceIdChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                                >
                                    <option value="0">Selectionnez votre service</option>
                                    {allServices.map(service => (
                                    <option key={service.id} value={service.id}>
                                        {service.name}
                                    </option>
                                    ))}
                                    {allServices.length === 0 && (
                                    <option value="" disabled>Aucun service disponible</option>
                                    )}
                                </select>
                                </div>
                            )}
                            {allSpaces && (
                                <div className="form-group w-full md:w-1/2">
                                <label htmlFor="categoryId" className="text-lg font-semibold mb-2">Liste des espaces</label>
                                <select
                                    name="categoryId"
                                    value={spaceIdEdit || 0}
                                    onChange={handleSpaceIdChange}
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring focus:ring-indigo-500 focus:ring-opacity-50"
                                >
                                    <option value={0}>Choisissez votre espace favori</option>
                                    {allSpaces.map(space => (
                                    <option key={space.id} value={space.id}>
                                        {space.name}
                                    </option>
                                    ))}
                                    {allSpaces.length === 0 && (
                                    <option value="" disabled>Aucun service disponible</option>
                                    )}
                                </select>
                                </div>
                            )}
                            {serviceIdEdit != 0 && spaceIdEdit !=0  && (
                                <button
                                type="submit"
                                className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                >
                                Confirmer la sélection
                                </button>
                            )}
                            </form>
                        </Modal>
                    </div>
                }
                <li className="navigationElement" onClick={() => void handleLogout()}>Se Déconnecter</li>
            {/* <Link to="/profil"><li className="burgerElement">Mon Profil</li></Link> */}
        </ul>
    );
}

export { BurgerMenu };